import { Rx } from "subtree.js/core";

export type WebsiteChoice = "own" | "hosted";

/** Fields the hosted branch can complain about, keyed for per-field messages. */
export type HostedField = "contactEmail" | "returnsPolicy";
export type HostedErrors = Partial<Record<HostedField, string>>;

export class OnboardingWebsiteState {
  readonly storeId = new Rx<string | null>(null);
  readonly claimWalkthrough = new Rx(false);
  readonly choice = new Rx<WebsiteChoice>("own");
  readonly websiteUrl = new Rx("");
  readonly slug = new Rx("");
  readonly contactEmail = new Rx("");
  readonly returnsPolicy = new Rx("");
  readonly hostedErrors = new Rx<HostedErrors>({});
  /** The handle's problem while the hosted branch is chosen; null otherwise. */
  readonly slugProblem = new Rx<string | null>(null);
  /** Whether any location has an address the page can print: the one requirement this screen cannot fix. */
  readonly hasMappableLocation = new Rx(false);
  readonly error = new Rx<string | null>(null);
  readonly busy = new Rx(false);
}

export abstract class OnboardingWebsiteActions {
  abstract setChoice(choice: WebsiteChoice): void;
  abstract setWebsiteUrl(value: string): void;
  abstract setSlug(value: string): void;
  abstract setContactEmail(value: string): void;
  abstract setReturnsPolicy(value: string): void;
  abstract submit(): Promise<void>;
  abstract back(): void;
}
